import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ArrowRight, ExternalLink, MapPin } from 'lucide-react';
import { getContactData } from '../services/api';

const Footer = () => {
  const [contactData, setContactData] = useState({
    email: 'Loading...', 
    whatsapp: 'Loading...',
    address: 'Loading Address...'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getContactData();
        if (data) {
          setContactData({
            email: data.email || 'imoonuselkonveksi@gmail.com',
            whatsapp: data.whatsapp || '+62 898-7459-759',
            address: data.address || 'Girimukti, Batujajar\nKabupaten Bandung Barat\nJawa Barat, 40561'
          });
        }
      } catch (error) {
        console.error("Failed to fetch contact data for footer", error);
        // Fallback to hardcoded if API fails
        setContactData({
          email: 'imoonuselkonveksi@gmail.com',
          whatsapp: '+62 898-7459-759',
          address: 'Girimukti, Batujajar\nKabupaten Bandung Barat\nJawa Barat, 40561'
        });
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="bg-black text-white pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-16 border-b border-zinc-800 pb-16">
          
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="text-3xl font-black tracking-tighter mb-8">
              iMoonusel<span className="text-blue-600">.</span>
            </div>
            <p className="text-zinc-300 text-base leading-relaxed mb-8">
              Mitra produksi tepercaya untuk brand fashion, corporate, dan instansi. Memberdayakan industri konveksi sejak 2012.
            </p>
          </div>
          
          {/* Company Links */}
          <div className="md:col-span-1">
            <h5 className="text-sm font-black uppercase tracking-widest text-zinc-300 mb-6 italic underline underline-offset-4 decoration-blue-600">
              Company
            </h5>
            <ul className="flex flex-col gap-3 text-base font-medium text-zinc-400 italic">
              <li><Link to="/about" className="hover:text-white transition-colors">Tentang Kami</Link></li>
              <li><Link to="/gallery" className="hover:text-white transition-colors">Gallery</Link></li>
              <li><Link to="/partnership" className="hover:text-white transition-colors">Kemitraan</Link></li>
              <li><Link to="/articles" className="hover:text-white transition-colors">Artikel</Link></li>
              <li><Link to="/karir" className="hover:text-white transition-colors">Karir</Link></li>
            </ul>
          </div>

          {/* Inquiry / Contact */}
          <div className="md:col-span-1">
            <h5 className="text-sm font-black uppercase tracking-widest text-zinc-300 mb-6 italic underline underline-offset-4 decoration-blue-600">
              Inquiry
            </h5>
            <ul className="flex flex-col gap-3 text-base font-medium text-zinc-400">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 shrink-0" /> 
                <span className="whitespace-pre-line">{contactData.address}</span>
              </li>
              <li className="flex items-center gap-2 mt-2">
                <Mail size={16} /> 
                <a href={`mailto:${contactData.email}`} className="hover:text-white transition-colors">
                  {contactData.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} /> 
                <a href={`https://wa.me/${contactData.whatsapp ? contactData.whatsapp.replace(/\D/g,'') : ''}`} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  {contactData.whatsapp}
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter (Visual Only) */}
          <div className="md:col-span-1 bg-zinc-900 p-8 rounded-sm">
            <h5 className="text-sm font-black uppercase tracking-widest text-white mb-4">
              Newsletter
            </h5>
            <p className="text-sm text-zinc-300 mb-4">
              Dapatkan update terbaru tentang tren fashion dan promo menarik.
            </p>
            <div className="flex">
              <input 
                type="text" 
                placeholder="Email address" 
                className="bg-black border border-zinc-800 px-4 py-2 text-sm flex-grow focus:outline-none focus:border-blue-600 text-white"
              />
              <button className="bg-blue-600 p-2 hover:bg-blue-700 transition-colors">
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-zinc-400 uppercase tracking-widest font-bold">
          <p>© {new Date().getFullYear()} iMoonusel Konveksi. ALL RIGHTS RESERVED.</p>
          <div className="flex gap-8 mt-4 md:mt-0">
            <Link to="#" className="hover:text-white">Privacy Policy</Link>
            <Link to="#" className="hover:text-white">Terms of Service</Link>
            <button onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})} className="hover:text-white flex items-center gap-1">
              Back to Top <ExternalLink size={10} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;